module.exports = __webpack_public_path__ + "img/favorites-outline-mobile.986e396.svg?v=1762502055057";